import { HistorySourceCodePresenter } from '@/presentation/presenters/history/historySourceCodePresenter'
import { HistorySourceCodeViewModel } from '@/presentation/viewmodels/history/historySourceCodeViewModel'

export function useHistorySourceCodePresenter(
  presenter: HistorySourceCodePresenter = new HistorySourceCodePresenter(new HistorySourceCodeViewModel())
) {
  return {
    historySourceCodeList: presenter.historySourceCodeList,
    isLoading: presenter.isLoading,
    error: presenter.error,
    fetchHistorySourceCodeList: presenter.fetchHistorySourceCodeList.bind(presenter)
  }
}
